<template>
  <div class="p-contentplans-writing-ai-phase">
    <slot>
      <Advice img="pencil" priority="low-gray">
        <p>
          上位10ページのタイトル・ディスクリプション・見出しテキストを参考に、不足している要素や自社ならではの考察・データを加え、見出し構成案を完成させましょう。
        </p>
      </Advice>
    </slot>
    <SerpsTitles
      :createdAt="createdAt"
      :errorAddHeading="errorAddHeading"
      :keyword="keyword"
      :project="project"
      :serpsTopItems="serpsTopItems"
      :serpsAllItems="items"
      :isEditMode="isEditMode"
      :isSerpsError="isError"
      :isSerpsLoading="isLoading"
      @addHeading="addHeading"
    />
    <SerpsHeadingCount
      :createdAt="createdAt"
      :project="project"
      :keyword="keyword"
      :serpsTopItems="serpsTopItems"
      :serpsAllItems="items"
      :isSerpsError="isError"
      :isSerpsLoading="isLoading"
      @addHeading="addHeading"
    />
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import SerpsHeadingCount from '@/components/contentPlans/writing/SerpsHeadingCount';
import SerpsTitles from '@/components/contentPlans/writing/SerpsTitles';
import axios from 'axios';
import apiProjects from '@/api/projects';

export default {
  props: ['createdAt', 'errorAddHeading', 'keyword', 'project', 'isEditMode'],
  components: {
    Advice,
    SerpsHeadingCount,
    SerpsTitles
  },
  data() {
    return {
      cancelToken: null,
      expiresAt: Date.now() + 10 * 60 * 1000,
      items: [],
      timeoutDelay: 30000,
      timeoutId: null,
      isError: false,
      isLoading: true
    };
  },
  computed: {
    serpsTopItems() {
      return this.items.slice(0, 10);
    }
  },
  created() {
    this.getSerps();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
    if (this.cancelToken) {
      this.cancelToken.cancel();
    }
  },
  methods: {
    addHeading(level, value) {
      this.$emit('addHeading', level, value);
    },
    getSerps() {
      const params = {
        keyword: this.keyword,
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        location: 'tokyo',
        engine: 'google',
        device: 'desktop',
        fromRank: 1,
        toRank: 100
      };
      this.cancelToken = axios.CancelToken.source();

      return apiProjects.serps
        .get(params, this.auth.idToken, this.project.id, this.cancelToken.token)
        .then(response => {
          this.items = response.data.items;
          this.isLoading = false;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            if (Date.now() < this.expiresAt) {
              this.timeoutId = setTimeout(this.getSerps, this.timeoutDelay);
            } else {
              this.isError = true;
              this.isLoading = false;
            }
          }
        });
    }
  }
};
</script>
